import { CaretIcon } from '@cycle-app/ui/icons';

import { mapAddOnsData } from 'src/constants/addOn.constants';
import { useOptimizedBooleanState, useProductAddOns } from 'src/hooks';

import { ListContainer, ToggleButton, Item, List } from './BillingUpgradeAddons.styles';

export const BillingUpgradeAddons = () => {
  const [isListExpanded, { toggleCallback: toggleList }] = useOptimizedBooleanState(false);
  const addons = useProductAddOns();
  const addonsEnabled = addons.filter(addon => addon.isEnabled);
  return (
    <>
      <ToggleButton
        disabled={!addonsEnabled.length}
        full
        onClick={toggleList}
        size="M"
        variant="light"
      >
        {addonsEnabled.length
          ? `You currently have ${addonsEnabled.length} add-on${addonsEnabled.length > 1 ? 's' : ''}`
          : 'You have no add-on yet'}
        {!!addonsEnabled.length && (
          <CaretIcon
            direction={isListExpanded ? 'top' : 'bottom'}
            height={10}
            width={10}
          />
        )}
      </ToggleButton>
      {isListExpanded && (
        <ListContainer>
          <List>
            {addonsEnabled.map(addon => <Item key={addon.name}>{mapAddOnsData[addon.name].name}</Item>)}
          </List>
        </ListContainer>
      )}
    </>
  );
};
